
import { defineComponent,ComputedRef,Ref,ref,reactive, onMounted, computed, toRefs, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

import { Props, validateInfos } from 'ant-design-vue/lib/form/useForm'
import { message, Form, Modal } from 'ant-design-vue';
import type { ShowSearchType } from 'ant-design-vue/es/cascader'
import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos';
import dayjs from 'dayjs'

import { LoadingOutlined, PlusOutlined, CloudUploadOutlined, CloudDownloadOutlined, InfoCircleOutlined } from '@ant-design/icons-vue';

import {StateType as EnterpriseStateType} from './store'
import {StateType as AreaStateType} from '@/store/area'
import {StateType as UploadStateType} from '@/store/upload'
import {StateType as UserStateType} from '@/store/user'
import {StateType as FddsignStateType} from '@/store/fddsign'

import {EnterpriseFormDataType} from './data.d'
import {AreaParams, ImageUrlParams, ShipmentOrderType} from '@/services/data.d'
import {arealistFn} from '@/utils/array'

import prefix from '@/utils/countryPrefix'
import downloadfile from '@/utils/download'
import fileUrl from '@/utils/downloadurl'

import {beforeUploadTypeSize} from '@/utils/upload'
import bank from '@/utils/bank'
import {isPhone,isIdcard,isUscode, isRunNian} from '@/utils/validate'
import {lt18gt65} from '@/utils/lt18gt65'

const useForm = Form.useForm;

interface ImgurlType{
    imgurl1: string;
    imgurl2: string;
    imgurl3: string;
    imgurl4: string;
    imgurl5: string;
    imgurl6: string;
}

interface loadingType{
    loading1: boolean;
    loading2: boolean;
    loading3: boolean;
    loading4: boolean;
    loading5: boolean;
    loading6: boolean;
}

interface EnterpriseSetupData{
    t: (key: string | number) => string;
    resetFields: (newValues?: Props) => void;
    modelRef: EnterpriseFormDataType;
    validateInfos: ComputedRef<validateInfos>;
    arealist: Ref<any>;
    prefixlist: any;
    imageUrl: ImgurlType;
    loadingType: loadingType;
    loadingM: Ref<boolean>;
    visible: Ref<boolean>;
    fddurl: Ref<string>;
    isMark: Ref<boolean>;
    certStatus: Ref<number | null>;
    banklist: any;
    handleSubmit: (e: MouseEvent) => void;
    handleUpload1: (info: any) => void;
    handleUpload2: (info: any) => void;
    handleUpload3: (info: any) => void;
    handleUpload4: (info: any) => void;
    handleUpload5: (info: any) => void;
    handleUpload6: (info: any) => void;
    handleModfiy: (e: MouseEvent) => void;
    handleChangeType: (e: any) => void;
    handleDownFile: (e: MouseEvent) => void;
    fddModal: (type: string, params?: any) => void;
    handleChangeForever: (val:any) => void;
    beforeUpload:(info: any) => void;
    handleCancel: (e: MouseEvent) => void;
    filter: ShowSearchType['filter'];
    filterOption: (input: string, option: any) => any,
    handleSetValue: (val: any) => any
}

export default defineComponent({
    name: 'Enterprise',
    components: {
        LoadingOutlined,
        PlusOutlined,
        CloudUploadOutlined,
        CloudDownloadOutlined,
        InfoCircleOutlined
    },
    emits: ['changeCertStatus'],
    setup(_, {emit}): EnterpriseSetupData {
        const { t } = useI18n()
        const store = useStore<{
            enterprise:EnterpriseStateType,
            area:AreaStateType,
            upload:UploadStateType,
            user:UserStateType,
            fddsign: FddsignStateType
        }>()
        const userMsg = JSON.parse(String(localStorage.getItem('userMsg')))
        const arealist = ref<any>([])
        const prefixlist = prefix
        const imageUrl = reactive<ImgurlType>({
            imgurl1:'',
            imgurl2:'',
            imgurl3:'',
            imgurl4:'',
            imgurl5:'',
            imgurl6:''
        })
        const loadingType = reactive<loadingType>({
            loading1: false,
            loading2: false,
            loading3: false,
            loading4: false,
            loading5: false,
            loading6: false
        })
        const loadingM = ref<boolean>(false)
        const visible = ref<boolean>(false)
        const fddurl = ref<string>('')
        const isMark = ref<boolean>(false)
        const usertype = store.state.user.currentUser.userType || 2
        const userEnterprise = store.state.user.currentUser.userEnterprise
        const bankDepositRegionData = usertype == 2 ? userEnterprise&&userEnterprise?.bankDepositRegion!=''&&JSON.parse(userEnterprise?.bankDepositRegion as any) : []
        const certStatus = ref<number | null>(store.state.user.currentUser.certStatus ?? null)
        const banklist = bank || []
        const checkType = ref<boolean>(false)
        let subnum = 0
        console.log('checktype', bankDepositRegionData);
        //表单数据
        const modelRef = reactive<EnterpriseFormDataType>({
            companyPrincipalType: userEnterprise?userEnterprise?.companyPrincipalType:1, //企业管理员
            email: userMsg.email, //邮箱
            enterpriseName: userEnterprise?userEnterprise?.enterpriseName:'', //企业名称
            representativeName: userEnterprise?userEnterprise?.representativeName:'', //法定代表人姓名
            legalName: userEnterprise?userEnterprise?.legalName:'', //法人姓名
            legalId: userEnterprise?userEnterprise?.legalId:'', //法人证件号(身份证号)
            legalMobile: userEnterprise?userEnterprise?.legalMobile:'', //法人手机号
            legalTime: userEnterprise?[userEnterprise?.legalValidityStartDate,userEnterprise?.legalValidityEndDate]:[], //法人证件有效期
            legalIsForever: userEnterprise?userEnterprise?.legalIsForever:false, //法人证件是否永久
            agentIsForever: userEnterprise?userEnterprise?.agentIsForever:false,  //企业管理人身份证是否永久
            contactAddress: userEnterprise?[userEnterprise?.province??'',userEnterprise?.city??'',userEnterprise?.region??'']:[], //联系地址
            detailedAddress: userEnterprise?userEnterprise?.detailedAddress:'', //详细地址
            creditCode: userEnterprise?userEnterprise?.creditCode:'', //统一社会信用代码
            validitytime: userEnterprise?[userEnterprise?.validityStartDate,userEnterprise?.validityEndDate]:[], //统一社会信用证件有效
            licenseAnnex: userEnterprise?userEnterprise?.licenseAnnex:'', //营业执照附件信息
            enterpriseCertAnnex: userEnterprise?userEnterprise?.enterpriseCertAnnex:'', //企业认证申请表
            legalIdAnnex1: userEnterprise?JSON.parse(String(userEnterprise?.legalIdAnnex))?.frontId:'', //法人证件信息(身份证/护照正面)
            legalIdAnnex2: userEnterprise?JSON.parse(String(userEnterprise?.legalIdAnnex))?.oppositeId:'', //法人证件信息(身份证/护照反面)
            bankId: userEnterprise?userEnterprise?.bankId:'', //银行账号
            bankName: userEnterprise?userEnterprise?.bankName:null, //开户银行
            subbranchName: userEnterprise?userEnterprise?.subbranchName:'', //开户支行
            bankDepositRegion: bankDepositRegionData&&bankDepositRegionData!=''? [bankDepositRegionData.province,bankDepositRegionData.city,bankDepositRegionData.region]:[], //开户行所在省市 ,
            agentName: userEnterprise?userEnterprise?.agentName:'', //企业管理姓名
            agentId: userEnterprise?userEnterprise?.agentId:'', //企业管理证件号(身份证号)
            isForever: userEnterprise?userEnterprise?.isForever:false, //统一认证证件是否永久
            agentTime: userEnterprise?[userEnterprise?.agentValidityStartDate,userEnterprise?.agentValidityEndDate]:[], //企业管理证件有效期
            agentMobile: userEnterprise?userEnterprise?.agentMobile:'', //企业管理手机号
            agentIdAnnex1: userEnterprise&&userEnterprise?.agentIdAnnex?JSON.parse(String(userEnterprise?.agentIdAnnex)).frontId:'', //企业管理证件信息(身份证/护照正面)
            agentIdAnnex2: userEnterprise&&userEnterprise?.agentIdAnnex?JSON.parse(String(userEnterprise?.agentIdAnnex)).oppositeId:'', //企业管理证件信息(身份证/护照反面)
        })
        const rulesRef = reactive({
            companyPrincipalType: [{
                required: true,
                message: '请选择企业管理员实名认证'
            }], //企业管理员
            email: [{
                required: true,
                message: '请输入邮箱'
            }], //邮箱
            enterpriseName: [{
                required: true,
                message: '请输入企业名称'
            }], //企业名称
            representativeName: [{
                required: true,
                message: '请输入法定代表人姓名'
            }], //法定代表人姓名
            legalName: [], //法人姓名
            legalId: [{
                required: true,
                validator: (rule: any, value: string, callback: any) => {
                    if(!checkType.value){
                        if(value == ''|| value==undefined){
                            return Promise.reject('请输入身份证号')
                        }else if(value.length === 18&&isIdcard(value)){
                            if((
                                value.substring(10,12)=='04'||
                                value.substring(10,12)=='06'||
                                value.substring(10,12)=='09'||
                                value.substring(10,12)=='11'
                            )&&value.substring(12,14)>='31'||value.substring(10,12)>='13'){
                                return Promise.reject('请输入正确的身份证号')
                            }else if((
                                value.substring(10,12)=='01'||
                                value.substring(10,12)=='03'||
                                value.substring(10,12)=='05'||
                                value.substring(10,12)=='07'||
                                value.substring(10,12)=='08'||
                                value.substring(10,12)=='10'||
                                value.substring(10,12)=='12'
                            )&&value.substring(12,14)>='32'||value.substring(10,12)>='13'){
                                return Promise.reject('请输入正确的身份证号')
                            }else if(isRunNian(value.substring(6,10))){//润年
                                if(value.substring(10,12)=='02'&&value.substring(12,14)>='30'){
                                    return Promise.reject('请输入正确的身份证号')
                                }else{
                                    return Promise.resolve()
                                }
                            }else{
                                if(value.substring(10,12)=='02'&&value.substring(12,14)>='29'){
                                    return Promise.reject('请输入正确的身份证号')
                                }else{
                                    return Promise.resolve()
                                }
                            }
                        }else{
                            return Promise.reject('请输入正确的身份证号')
                        }
                    }else{
                        return Promise.resolve()
                    }
                }
            }], //法人证件号(身份证号)
            legalTime: [{
                required: true,
                validator: (rule: any, value: string, callback: any) => {
                    if(!checkType.value){
                        if(!modelRef.legalIsForever){
                            if(value[0]==''&&value[1]==='' || value[0]==undefined&&value[1]==undefined || value[0]==null&&value[1]===null){
                                return Promise.reject('请选择法定代表人身份证号有效期')
                            }else{
                                return Promise.resolve()
                            }
                        }else{
                            return Promise.resolve()
                        }
                    }else{
                        return Promise.resolve()
                    }
                }
            }],//法人证件有效期
            legalMobile: [{
                required: true,
                validator: (rule:any,value:string, callback: any)=>{
                    if(!checkType.value){
                        if(value===''||value==undefined){
                            return Promise.reject('请输入联系电话')
                        }else{
                            if(isPhone(value)){
                                return Promise.resolve()
                            }else{
                                return Promise.reject('请输入正确的手机号电话')
                            }
                        }
                    }else{
                        return Promise.resolve()
                    }
                }
            }], //法人手机号
            legalIsForever: [], //法人证件是否永久
            isForever: [], // 统一信用代码
            agentIsForever:[], //代理人证件是否永久
            contactAddress: [{
                required: true,
                message: '请选择联系地址'
            }], //联系地址
            detailedAddress: [{
                required: true,
                message: '请输入详细地址'
            }], //详细地址
            creditCode: [{
                required: true,
                validator: (rule:any,value:string, callback: any)=>{
                    if(value===''||value==undefined){
                        return Promise.reject('请输入统一社会信用代码')
                    }else{
                        if(isUscode(value)){
                            return Promise.resolve()
                        }else{
                            return Promise.reject('请输入正确的统一社会信用代码')
                        }
                    }
                }
            }], //统一社会信用代码
            validitytime: [{
                required: true,
                validator: (rule: any, value: string, callback: any) => {
                    if(!modelRef.isForever){
                        if(value[0]==''&&value[1]==='' || value[0]==undefined&&value[1]==undefined || value[0]==null&&value[1]===null){
                            return Promise.reject('请选择统一社会信用证件有效期')
                        }else{
                            return Promise.resolve()
                        }
                    }else{
                        return Promise.resolve()
                    }
                }
            }], //统一社会信用证件有效
            licenseAnnex: [{
                required: true,
                message: '请上传营业执照扫描件'
            }], //营业执照附件信息
            enterpriseCertAnnex: [{
                required: false,
                message: '请上传企业认证申请表'
            }],//企业认证申请表
            legalIdAnnex1: [{
                required: true,
                message: '请上传法定代表人证件正面'
            }], //法人证件信息
            legalIdAnnex2: [{
                required: true,
                message: '请上传法定代表人证件反面'
            }], //法人证件信息
            bankId: [{
                required: true,
                message: '请输入对公银行账号'
            }], //银行账号
            bankName: [{
                required: true,
                message: '请选择开户银行'
            }], //开户银行
            subbranchName: [{
                required: true,
                message: '请输入开户银行支行'
            }], //开户支行
            bankDepositRegion: [{
                required: true,
                message: '请选择支行所在省市'
            }], //开户行所在省市
            agentName: [{
                required: false,
                message: '请输入企业管理人姓名'
            }], //代理人姓名
            agentId: [{
                required: false,
                validator: (rule:any,value:string, callback: any) => {
                    if(checkType.value){
                        if(value == ''|| value==undefined){
                            return Promise.reject('请输入身份证号')
                        }else if(value.length === 18&&isIdcard(value)){
                            if((
                                value.substring(10,12)=='04'||
                                value.substring(10,12)=='06'||
                                value.substring(10,12)=='09'||
                                value.substring(10,12)=='11'
                            )&&value.substring(12,14)>='31'){
                                return Promise.reject('请输入正确的身份证号')
                            }else if((
                                value.substring(10,12)=='01'||
                                value.substring(10,12)=='03'||
                                value.substring(10,12)=='05'||
                                value.substring(10,12)=='07'||
                                value.substring(10,12)=='08'||
                                value.substring(10,12)=='10'||
                                value.substring(10,12)=='12'
                            )&&value.substring(12,14)>='32'){
                                return Promise.reject('请输入正确的身份证号')
                            }else if(isRunNian(value.substring(6,10))){//润年
                                if(value.substring(10,12)=='02'&&value.substring(12,14)>='30'){
                                    return Promise.reject('请输入正确的身份证号')
                                }else{
                                    return Promise.resolve()
                                }
                            }else{
                                if(value.substring(10,12)=='02'&&value.substring(12,14)>='29'){
                                    console.log('平年');
                                    return Promise.reject('请输入正确的身份证号')
                                }else{
                                    return Promise.resolve()
                                }
                            }
                        }else{
                            return Promise.reject('请输入正确的身份证号')
                        }
                    }else{
                        return Promise.resolve()
                    }
                }
            }], //代理人证件号(身份证号)
            agentTime: [{
                required: true,
                validator: (rule: any, value: string, callback: any) => {
                    if(checkType.value){
                        if(!modelRef.agentIsForever){
                            if(value[0]==''&&value[1]==='' || value[0]==undefined&&value[1]==undefined || value[0]==null&&value[1]===null){
                                return Promise.reject('请选择企业管理人身份证号有效期')
                            }else{
                                return Promise.resolve()
                            }
                        }else{
                            return Promise.resolve()
                        }
                    }else{
                        return Promise.resolve()
                    }
                }
            }], //代理人证件有效期
            agentMobile: [{
                required: false,
                validator: (rule:any,value:string, callback: any)=>{
                    if(checkType.value){
                        if(value===''|| value==undefined){
                            return Promise.reject('请输入联系电话')
                        }else{
                            if(isPhone(value)){
                                return Promise.resolve()
                            }else{
                                return Promise.reject('请输入正确的手机号电话')
                            }
                        }
                    }else{
                        return Promise.resolve()
                    }
                }
            }], //代理人手机号
            agentIdAnnex1: [{
                required: false,
                message: '请上传企业管理人身份证正面'
            }], //代理人证件信息(身份证正反面)
            agentIdAnnex2: [{
                required: false,
                message: '请上传企业管理人身份证反面'
            }], //代理人证件信息(身份证正反面)
        })


        //改变实名认证
        const handleChangeType = (e: any) => {
            let val = typeof e === 'object' ? e?.target?.value : e
            if(val == 1){
                rulesRef.legalId[0].required = true
                rulesRef.legalTime[0].required = true
                rulesRef.legalMobile[0].required = true
                rulesRef.legalIdAnnex1[0].required = true
                rulesRef.legalIdAnnex2[0].required = true
                rulesRef.enterpriseCertAnnex[0].required = false
                rulesRef.agentName[0].required = false
                rulesRef.agentId[0].required = false
                rulesRef.agentTime[0].required = false
                rulesRef.agentMobile[0].required = false
                rulesRef.agentIdAnnex1[0].required = false
                rulesRef.agentIdAnnex2[0].required = false
                checkType.value = false
            }else{
                rulesRef.agentName[0].required = true
                rulesRef.agentId[0].required = true
                rulesRef.agentTime[0].required = true
                rulesRef.agentMobile[0].required = true
                rulesRef.agentIdAnnex1[0].required = true
                rulesRef.agentIdAnnex2[0].required = true
                rulesRef.enterpriseCertAnnex[0].required = true
                rulesRef.legalId[0].required = false
                rulesRef.legalTime[0].required = false
                rulesRef.legalMobile[0].required = false
                rulesRef.legalIdAnnex1[0].required = false
                rulesRef.legalIdAnnex2[0].required = false
                checkType.value = true
            }
        }

        //提交数据
        const { resetFields, validate, validateInfos } = useForm(modelRef, rulesRef)
        const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos)
        const handleSubmit = async(e:MouseEvent) => {
            e.preventDefault()
            try {
                const fieldsValue = await validate<EnterpriseFormDataType>()
                //统一社会信用证件有效
                let vst = fieldsValue.validitytime&&fieldsValue.validitytime[0]||''
                let vet = fieldsValue.validitytime&&fieldsValue.validitytime[1]||''
                let validityStartDate = vst==''?'':dayjs(vst).format('YYYY-MM-DD 00:00:00')
                let validityEndDate = vst==''?'':dayjs(vet).format('YYYY-MM-DD 23:59:59')
                const bankDepositRegionNew = (fieldsValue.bankDepositRegion as any[])
                const bankDepositRegion = {
                    province:bankDepositRegionNew[0],
                    city:bankDepositRegionNew[1],
                    region:bankDepositRegionNew[2]
                }
                //共有字段
                const formdata = {
                    companyPrincipalType: fieldsValue.companyPrincipalType,
                    enterpriseName: fieldsValue.enterpriseName,
                    representativeName: fieldsValue.representativeName,
                    province: (fieldsValue.contactAddress as any[])[0]||'',
                    city: (fieldsValue.contactAddress as any[])[1]||'',
                    region: (fieldsValue.contactAddress as any[])[2]||'',
                    detailedAddress: fieldsValue.detailedAddress,
                    creditCode: fieldsValue.creditCode,
                    isForever: fieldsValue.isForever,
                    validityStartDate,
                    validityEndDate,
                    licenseAnnex: fieldsValue.licenseAnnex,
                    enterpriseCertAnnex: fieldsValue.enterpriseCertAnnex,
                    bankId: fieldsValue.bankId,
                    bankName: fieldsValue.bankName,
                    subbranchName: fieldsValue.subbranchName,
                    bankDepositRegion: JSON.stringify(bankDepositRegion),
                    userType: usertype,
                    userCode: userMsg.userCode,
                }
                //法定代表人字段
                let lest = fieldsValue.legalTime&&fieldsValue.legalTime[0]||''
                let leet = fieldsValue.legalTime&&fieldsValue.legalTime[1]||''
                let legalValidityStartDate = lest==''?'':dayjs(lest).format('YYYY-MM-DD 00:00:00')
                let legalValidityEndDate = leet==''?'':dayjs(leet).format('YYYY-MM-DD 23:59:59')
                const formdata1 = {
                    legalName: fieldsValue.representativeName,
                    legalId: fieldsValue.legalId,
                    legalMobile: fieldsValue.legalMobile,
                    legalValidityStartDate,
                    legalValidityEndDate,
                    legalIsForever: fieldsValue.legalIsForever,
                    legalIdAnnex: JSON.stringify({frontId:fieldsValue.legalIdAnnex1, oppositeId:fieldsValue.legalIdAnnex2}),
                    contactsPhone: fieldsValue.legalMobile
                }
                //企业管理人字段
                let agst = fieldsValue.agentTime&&fieldsValue.agentTime[0]||''
                let aget = fieldsValue.agentTime&&fieldsValue.agentTime[1]||''
                let agentValidityStartDate = agst==''?'':dayjs(agst).format('YYYY-MM-DD 00:00:00')
                let agentValidityEndDate = aget==''?'':dayjs(aget).format('YYYY-MM-DD 23:59:59')
                const formdata2 = {
                    agentName: fieldsValue.agentName,
                    agentId: fieldsValue.agentId,
                    agentMobile: fieldsValue.agentMobile,
                    agentValidityStartDate,
                    agentValidityEndDate,
                    agentIsForever: fieldsValue.agentIsForever,
                    agentIdAnnex: JSON.stringify({frontId:fieldsValue.agentIdAnnex1, oppositeId:fieldsValue.agentIdAnnex2}),
                    contactsPhone: fieldsValue.agentMobile
                }
                let params = {}
                fieldsValue.companyPrincipalType == 1 ? params = {...formdata, ...formdata1} : params = {...formdata, ...formdata2}
                if(fieldsValue.legalId&&lt18gt65(fieldsValue.legalId) || fieldsValue.agentId&&lt18gt65(fieldsValue.agentId)){
                    const res:boolean = await store.dispatch('enterprise/saveUserEnterpriseFn',params)
                    if(res===true){
                        const data = {
                            id1:{id:fieldsValue.licenseAnnex},
                            id2:{id:fieldsValue.enterpriseCertAnnex},
                        }
                        const data1 = {
                            id3:{id:fieldsValue.legalIdAnnex1},
                            id4:{id:fieldsValue.legalIdAnnex2},
                        }
                        const data2 = {
                            id5:{id:fieldsValue.agentIdAnnex1},
                            id6:{id:fieldsValue.agentIdAnnex2},
                        }
                        const params = fieldsValue.companyPrincipalType == 1 ? {...data,...data1} : {...data,...data2}
                        fddModal('first',params)
                    }
                }else{
                    message.warning('18周岁以下，65周岁以上不允许进行注册')
                }
            } catch (error) {
                console.log(error);
                message.warning('error=>数据校验不通过，请检查')
            }
        }

        //获取地址
        const areaList = async(params:AreaParams) => {
            try {
                const res:boolean = await store.dispatch('area/getAreaFn', params)
                if(res){
                    arealist.value = arealistFn(store.state.area.arealist,1)
                }
            } catch (error) {
                message.warning('获取地区信息失败!')
            }
        }

        //上传营业执照
        const handleUpload1 = async(info: any) => uploadImageFn(info,'1')
        //上传企业认证申请表
        const handleUpload2 = async(info: any) => uploadImageFn(info,'2')
        //上传企业管理人证件正面
        const handleUpload3 = async(info: any) => uploadImageFn(info,'3')
        //上传企业管理人证件反面
        const handleUpload4 = async(info: any) => uploadImageFn(info,'4')
        //上传代理人证件正面
        const handleUpload5 = async(info: any) => uploadImageFn(info,'5')
        //上传代理人证件反面
        const handleUpload6 = async(info: any) => uploadImageFn(info,'6')

        //上传各类图片
        const uploadImageFn = (info: any, type:string) => {
            const formdata = new FormData()
            formdata.append('file',info.file)
            formdata.append('fileType', '1')
            uploadImage(formdata,type)
        }

        //上传前图片类型大小限制
        const beforeUpload = (info:any) => {
            return beforeUploadTypeSize(info)
        }

        //上传图片请求
        const uploadImage = async(params:any, type:string) => {
            if(type === '1'){loadingType.loading1 = true}
            if(type === '2'){loadingType.loading2 = true}
            if(type === '3'){loadingType.loading3 = true}
            if(type === '4'){loadingType.loading4 = true}
            if(type === '5'){loadingType.loading5 = true}
            if(type === '6'){loadingType.loading6 = true}
            try {
                const res:boolean = await store.dispatch('upload/uploadFileFn',params)
                if(res === true){
                    if(type === '1'){modelRef.licenseAnnex = store.state.upload.uploadRes.id}
                    if(type === '2'){modelRef.enterpriseCertAnnex = store.state.upload.uploadRes.id}
                    if(type === '3'){modelRef.legalIdAnnex1 = store.state.upload.uploadRes.id}
                    if(type === '4'){modelRef.legalIdAnnex2 = store.state.upload.uploadRes.id}
                    if(type === '5'){modelRef.agentIdAnnex1 = store.state.upload.uploadRes.id}
                    if(type === '6'){modelRef.agentIdAnnex2 = store.state.upload.uploadRes.id}
                    const data = {id: store.state.upload.uploadRes.id}
                    imageUrlRes(data,type)
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
            if(type === '1'){loadingType.loading1 = false}
            if(type === '2'){loadingType.loading2 = false}
            if(type === '3'){loadingType.loading3 = false}
            if(type === '4'){loadingType.loading4 = false}
            if(type === '5'){loadingType.loading5 = false}
            if(type === '6'){loadingType.loading6 = false}
        }
        //获取返回的图片地址
        const imageUrlRes = async(params:ImageUrlParams,type?:string) => {
            try {
                const res:boolean = await store.dispatch('upload/getImgUrlFn',params)
                if(res === true){
                    if(type === '1'){imageUrl.imgurl1 = store.state.upload.imageUrlRes.fileUrl}
                    if(type === '2'){imageUrl.imgurl2 = store.state.upload.imageUrlRes.fileUrl}
                    if(type === '3'){imageUrl.imgurl3 = store.state.upload.imageUrlRes.fileUrl}
                    if(type === '4'){imageUrl.imgurl4 = store.state.upload.imageUrlRes.fileUrl}
                    if(type === '5'){imageUrl.imgurl5 = store.state.upload.imageUrlRes.fileUrl}
                    if(type === '6'){imageUrl.imgurl6 = store.state.upload.imageUrlRes.fileUrl}
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
        }

        //成功后修改
        const handleModfiy = (e: MouseEvent) => {
            e.preventDefault()
            certStatus.value = null
        }

        //法大大认证
        const url = computed<string>(() => store.state.fddsign.signUrl)
        const fddAction = async(params:ShipmentOrderType,data?:any) => {
            loadingM.value = true
            try {
                const res: boolean = await store.dispatch('fddsign/fddAuthenticationFn', params)
                if(res===true){
                    data&&getEnterpriseInfo(data)
                    visible.value = true
                    fddurl.value = url.value
                }else{
                    data&&getEnterpriseInfo(data)
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
            loadingM.value = false
        }

        //法大大认证弹框
        const fddModal = (type: string, params?: any) => {
            Modal.confirm({
                title: '提示',
                content: '请确认您的认证信息填写是否正确。',
                okText: '确认',
                cancelText: '取消',
                onOk(){
                    if(type === 'first'){
                        fddAction({userCode: userMsg.userCode},params)
                    }else{
                        fddAction({userCode: userMsg.userCode},params)
                    }
                },
                onCancel(){
                    subnum += 1
                    if(subnum < 2){
                        params&&getEnterpriseInfo(params)
                    }
                }
            })
        }

        //数据回调
        const getEnterpriseInfo = async(params?:any) => {
            try {
               const res: boolean = await store.dispatch('user/fetchCurrent', {userCode: userMsg?.userCode})
               if(res === true){
                    certStatus.value = store.state.user.currentUser.certStatus
                    imageUrlRes(params.id1,'1')
                    if(modelRef.companyPrincipalType === 1){
                        imageUrlRes(params.id3,'3')
                        imageUrlRes(params.id4,'4')
                    }else{
                        imageUrlRes(params.id2,'2')
                        imageUrlRes(params.id5,'5')
                        imageUrlRes(params.id6,'6')
                    }
                    emit('changeCertStatus', true)
               }
            } catch (error) {
                message.warning('error=>'+error)
            }
        }

        //下载模版
        const handleDownFile = (e: MouseEvent) => {
            const data = {id:'2437'}
            try {
                downloadfile({
                    params: data,
                    url: fileUrl.filedownurl,
                    meth: 'get',
                    type: 'text/plain',
                    filename: `企业认证申请表_${new Date().getTime()}.doc`
                })
            } catch (error) {
                message.warning('error=>'+error)
            }
        }

        //点击统一社会信用证有效期长期有效
        const handleChangeForever = (val: any) => {
            if(val.target.name == 'isForever'){
                if(val.target.checked){
                    rulesRef.validitytime[0].required = false
                    modelRef.validitytime = []
                }else{
                    rulesRef.validitytime[0].required = true
                }
            }else if(val.target.name == 'legalIsForever'){
                if(val.target.checked){
                    rulesRef.legalTime[0].required = false
                    modelRef.legalTime = []
                }else{
                    rulesRef.legalTime[0].required = true
                }
            }else{
                if(val.target.checked){
                    rulesRef.agentTime[0].required = false
                    modelRef.agentTime = []
                }else{
                    rulesRef.agentTime[0].required = true
                }
            }
        }

        //点击右上角关闭按钮回调
        let timer:any = null
        const handleCancel = (e: MouseEvent) => {
            console.log('ttt');
            isMark.value = true
            let num = 0
            timer = setInterval(()=>{
                num += 1
                if(num >= 5){
                    isMark.value = false
                    num = 0
                    clearInterval(timer)
                    location.reload()
                }
            },1000)
        }

        //模糊查询省市
        const filter:ShowSearchType['filter'] = (inputValue:any, path:any) => {
            console.log('inputvalue', inputValue);
            console.log('path', path);
            return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
        }

        //过滤银行
        const filterOption = (input: string, option: any) => {
            return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }

        const handleSetValue = (val: any) => {
            console.log('val', val);
        }

        const init = () => {
            areaList({countryCode: '156'})
            modelRef.licenseAnnex ? imageUrlRes({id: modelRef.licenseAnnex}, '1') : null
            modelRef.enterpriseCertAnnex ? imageUrlRes({id: modelRef.enterpriseCertAnnex}, '2') : null
            modelRef.legalIdAnnex1 ? imageUrlRes({id: modelRef.legalIdAnnex1}, '3') : null
            modelRef.legalIdAnnex2 ? imageUrlRes({id: modelRef.legalIdAnnex2}, '4') : null
            modelRef.agentIdAnnex1 ? imageUrlRes({id: modelRef.agentIdAnnex1}, '5') : null
            modelRef.agentIdAnnex2 ? imageUrlRes({id: modelRef.agentIdAnnex2}, '6') : null
            handleChangeType(modelRef.companyPrincipalType)
        }
        onMounted(()=>{
            init()
        })

        return {
            t,
            modelRef,
            validateInfos:validateInfosNew,
            arealist,
            prefixlist,
            imageUrl,
            loadingType,
            loadingM,
            visible,
            fddurl,
            isMark,
            banklist,
            resetFields,
            certStatus,
            handleSubmit,
            handleUpload1,
            handleUpload2,
            handleUpload3,
            handleUpload4,
            handleUpload5,
            handleUpload6,
            handleModfiy,
            handleChangeType,
            handleDownFile,
            fddModal,
            handleChangeForever,
            beforeUpload,
            handleCancel,
            filter,
            filterOption,
            handleSetValue
        }
    }
})
